<template>
  <LoadingIndicator 
      v-if="showLoadingIndicator"
      topic="Surveys"
    />
  <div v-else>
    <b-table
      v-if="surveys.length > 0"
      class="custom-table"
      responsive
      :items="surveys"
      :fields="fields"
      sort-icon-
    >
      <template #cell(name)="{ item }">
        {{item.name}}
      </template>
      <template #cell(kebab)="data">
        <b-overlay class="text-right">
          <b-dropdown
            id="dropdown-1"
            class="kebab"
            text="Additional Options"
            variant="tertiary"
            no-caret
          >
            <template #button-content>
              <b-icon
                class="icon kebab additional"
                icon="three-dots-vertical"
                font-scale="1"
              ></b-icon
              ><span class="sr-only">Additional Options</span>
            </template>
            <b-dropdown-item @click="exportSurveyResults(data.item.id)">
              Export Results
            </b-dropdown-item>
          </b-dropdown>
        </b-overlay>
      </template>
    </b-table>
    <span v-else>
      No Facilitator Surveys
    </span>
  </div>
</template>

<script>
import axios from "axios";


export default {
  name: "FacilitatorTab",
  props: {
    surveys: { type: Array, default: () => [] }
  },
  data() {
    return {
      showLoadingIndicator: true,
      sending: false,
      fields: [
        { key: "name", label: "Meeting Name", sortable: true },
        { key: "kebab", label: "" },
      ]
    };
  },
  mounted() {
    window.setTimeout(() => {
      this.showLoadingIndicator = false;
    }, 200);
  },
  methods: {
    exportSurveyResults(surveyId) {
      this.sending = true;
       axios
        .get(`${this.$api_url}/surveys/${surveyId}/results-export`, this.getReqConfig({ responseType: 'blob' }))
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Survey Results.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(error => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }
}
</script>